import { AiFillHome, AiFillQuestionCircle, AiOutlineLineChart, AiFillReconciliation, AiFillCalendar, AiOutlineMail, AiOutlineTranslation } from 'react-icons/ai';
import { FaBarcode, FaBriefcaseMedical, FaNotesMedical, FaUsers, FaStethoscope, FaTools, FaDna } from 'react-icons/fa';
import { IoIosBusiness } from 'react-icons/io';
import { IoBusinessSharp } from 'react-icons/io5';
import actions from 'roles-actions-permissions/actions';
import { HiOutlineDocumentReport } from 'react-icons/all';
import DoctorKitCorrelationPage from 'components/business/DoctorKitCorrelationPage';
import DoctorKitsPage from 'pages/DoctorKitsPage';
import CorporateKitsPage from 'pages/CorporateKitsPage';
import BioAgeReportsPage from 'pages/BioAgeReportsPage';
import EmailTemplates from 'pages/EmailTemplates';
import TranslationsPage from 'pages/TranslationsPage';
import NgReportsPage from 'pages/NgReportsPage';
import UpgradedKitsPages from 'pages/UpgradedKitsPage';
import PromoCodes from 'components/business/PromoCodes';
import LabFilesPage from 'pages/LabFilesPage';
import LabSamplesPage from 'pages/LabSamplesPage';
import PGxReportsPage from 'pages/PGxReportsPage';
import SerialNumberDetails from 'pages/SerialDashboard';
import NutritionPage from 'pages/NutritionPage';
import VitaminsPage from 'pages/VitaminsPage';
import ThreeInOnePage from 'pages/ThreeInOnePage';
import ManagerRegistrationTabPage from 'pages/ManagerRegistrationTabPage';
import ManagerDoctorsPage from 'pages/ManagersDoctorsPage';
import ManagerSerialPage from 'pages/ManagerSerialPage';
import ManagerCorporatePage from 'pages/ManagerCorporatePage';
import ManagerSerialDashboardPage from 'pages/ManagerSerialDashboardPage';
import TraitsPage from '../../../pages/TraitsPage';
import AppointmentsPage from '../../../pages/AppointmentsPage';
import AssociationReportsPage from '../../../pages/AssociationReportsPage';
import SerialNumbersPage from '../../../pages/SerialNumbersPage';
import UsersPage from '../../../pages/UsersPage';
import ThematicPage from '../../../pages/ThematicPage';
import HomePage from '../../../pages/HomePage';
import ReportsPage from '../../../pages/ReportsPage';
import ConcentsPage from '../../../pages/ConsentsPage';
import QuestionnairesPage from '../../../pages/QuestionnairesPage';
import DoctorManagementPage from '../../../pages/DoctorManagementPage';
// import BusinessManagement from '../../../pages/BusinessManagement';

// const NotImplemented = () => {
//   return <div>Not implemented yet</div>;
// };
const data = [
  {
    icon: AiFillHome,
    title: 'Home',
    path: '/',
    permissions: actions.VIEW_HOME_PAGE,
    component: HomePage,
    menu: 'main',
  },
  {
    icon: AiOutlineLineChart,
    title: 'Reports',
    path: '/reports-folder',
    permissions: actions.VIEW_REPORTS_MENU,
    menu: 'folder',
  },
  {
    icon: AiOutlineLineChart,
    title: 'Cardio Health Reports',
    path: '/cardio-reports',
    permissions: actions.VIEW_CARDIO_REPORTS_PAGE,
    component: ReportsPage,
    menu: 'reports',
  },
  {
    icon: AiOutlineLineChart,
    title: '3in1 Reports',
    path: '/3in1-reports',
    permissions: actions.VIEW_3IN1_REPORTS_PAGE,
    component: ThreeInOnePage,
    menu: 'reports',
  },
  {
    icon: AiOutlineLineChart,
    title: 'Nutrition Reports',
    path: '/nutrition-reports',
    permissions: actions.VIEW_NUTRITION_REPORTS_PAGE,
    component: NutritionPage,
    menu: 'reports',
  },
  {
    icon: AiOutlineLineChart,
    title: 'Vitamins Reports',
    path: '/vitamins-reports',
    permissions: actions.VIEW_VITAMINS_REPORTS_PAGE,
    component: VitaminsPage,
    menu: 'reports',
  },
  {
    icon: AiOutlineLineChart,
    title: 'Biological Age Reports',
    path: '/bio-age-reports',
    permissions: actions.VIEW_BIO_AGE_REPORTS_PAGE,
    component: BioAgeReportsPage,
    menu: 'reports',
  },
  {
    icon: AiOutlineLineChart,
    title: 'Nutrigenetix Reports',
    path: '/nutrigenetix-reports',
    permissions: actions.VIEW_NG_REPORTS_PAGE,
    component: NgReportsPage,
    menu: 'reports',
  },
  {
    icon: AiOutlineLineChart,
    title: 'PGx Reports',
    path: '/pgx-reports',
    permissions: actions.VIEW_PGX_REPORTS_PAGE,
    component: PGxReportsPage,
    menu: 'reports',
  },
  {
    icon: FaBarcode,
    title: 'Serial',
    path: '/serial-folder',
    permissions: actions.VIEW_SERIAL_NUMBERS_PAGE,
    menu: 'folder',
  },
  {
    icon: FaBarcode,
    title: 'Serial Numbers',
    path: '/serial-numbers',
    permissions: actions.VIEW_SERIAL_NUMBERS_PAGE,
    component: SerialNumbersPage,
    menu: 'serial',
  },
  {
    icon: FaBarcode,
    title: 'Serial Dashboard',
    path: '/serial_details',
    permissions: actions.VIEW_SERIAL_NUMBERS_PAGE,
    component: SerialNumberDetails,
    menu: 'serial',
  },
  {
    icon: AiFillReconciliation,
    title: 'Registration',
    path: '/registration-folder',
    permissions: actions.VIEW_REGISTRATION_MENU,
    menu: 'folder',
  },
  {
    icon: FaStethoscope,
    title: 'Doctor kit management',
    path: '/doctor_kit_management',
    permissions: actions.VIEW_DOCTOR_KITS_PAGE,
    component: DoctorKitsPage,
    menu: 'registration',
  },
  {
    icon: IoBusinessSharp,
    title: 'Corporate kit management',
    path: '/corporate_kit_management',
    permissions: actions.VIEW_CORPORATE_KITS_PAGE,
    component: CorporateKitsPage,
    menu: 'registration',
  },
  {
    icon: AiFillReconciliation,
    title: 'Registration kit management',
    path: '/registration_kit_management',
    permissions: actions.VIEW_KITS_PAGE,
    component: ConcentsPage,
    menu: 'registration',
  },
  {
    icon: FaStethoscope,
    title: 'Doctor - Kit Correlation',
    path: '/doctors-kit-correlation',
    permissions: actions.VIEW_DOCTOR_PAGE,
    component: DoctorKitCorrelationPage,
    menu: 'registration',
  },
  {
    icon: FaUsers,
    title: 'B2B Management',
    path: '/b2bFolder',
    permissions: actions.VIEW_MANAGEMENT_MENU,
    menu: 'folder',
  },
  {
    icon: FaStethoscope,
    title: 'Doctor Management',
    path: '/doctors',
    permissions: actions.VIEW_DOCTOR_PAGE,
    component: DoctorManagementPage,
    menu: 'management',
  },
  {
    icon: IoIosBusiness,
    title: 'Corporate Accounts Management',
    path: '/corporation-management',
    permissions: actions.VIEW_BUSINESS_MANAGEMENT_PAGE,
    component: ManagerCorporatePage,
    menu: 'management',
  },
  {
    icon: FaTools,
    title: 'Tools',
    path: '/tools-folder',
    permissions: actions.VIEW_TOOLS_MENU,
    menu: 'folder',
  },
  {
    icon: AiFillCalendar,
    title: 'Appointments',
    path: '/appointments',
    permissions: actions.VIEW_APPOINTMENTS_PAGE,
    component: AppointmentsPage,
    menu: 'tools',
  },
  {
    icon: AiOutlineTranslation,
    title: 'Translations',
    path: '/translations',
    permissions: actions.VIEW_TRANSLATIONS_PAGE,
    component: TranslationsPage,
    menu: 'tools',
  },
  {
    icon: AiFillQuestionCircle,
    title: 'Questionnaires',
    path: '/questions',
    permissions: actions.VIEW_QUESTIONS_PAGE,
    component: QuestionnairesPage,
    menu: 'tools',
  },
  {
    icon: AiOutlineMail,
    title: 'Email Templates',
    path: '/email-templates',
    permissions: actions.VIEW_EMAIL_TEMPLATES_PAGE,
    component: EmailTemplates,
    menu: 'tools',
  },
  {
    icon: AiFillReconciliation,
    title: 'Promo Codes',
    path: '/promo-codes',
    permissions: actions.VIEW_PROMO_CODES_PAGE,
    component: PromoCodes,
    menu: 'tools',
  },
  {
    icon: HiOutlineDocumentReport,
    title: 'Miscellaneous',
    path: '/miscellaneous-folder',
    permissions: actions.VIEW_MISCELLANEOUS_MENU,
    menu: 'folder',
  },
  {
    icon: FaBriefcaseMedical,
    title: 'Thematic Packages',
    path: '/thematic',
    permissions: actions.VIEW_THEMATIC_PACKAGE_PAGE,
    component: ThematicPage,
    menu: 'miscellaneous',
  },
  {
    icon: FaNotesMedical,
    title: 'Traits',
    path: '/traits',
    permissions: actions.VIEW_TRAITS_PAGE,
    component: TraitsPage,
    menu: 'miscellaneous',
  },
  {
    icon: HiOutlineDocumentReport,
    title: 'Association Reports',
    path: '/association-reports',
    permissions: actions.VIEW_ASSOCIATION_REPORTS_PAGE,
    component: AssociationReportsPage,
    menu: 'miscellaneous',
  },
  // {
  //   icon: FiPackage,
  //   title: 'Diagnostic Packages',
  //   path: '/diagnosticPackages',
  //   permissions: actions.VIEW_DIAGNOSTIC_PACKAGE_PAGE,
  //   component: NotImplemented,
  //   menu: 'miscellaneous',
  // },
  // {
  //   icon: FaClinicMedical,
  //   title: 'Diagnostic Units',
  //   path: '/diagnosticUnits',
  //   permissions: actions.VIEW_DIAGNOSTIC_UNITS_PAGE,
  //   component: NotImplemented,
  //   menu: 'miscellaneous',
  // },
  {
    icon: AiOutlineLineChart,
    title: 'Upgraded kits',
    path: '/upgraded-kits',
    permissions: actions.VIEW_UPGRADED_KITS_PAGE,
    component: UpgradedKitsPages,
    menu: 'miscellaneous',
  },
  // {
  //   icon: AiOutlineLineChart,
  //   title: 'Reports',
  //   path: '/reports',
  //   permissions: actions.VIEW_REPORTS_PAGE,
  //   component: RemainingReportsPage,
  //   menu: 'main',
  // },
  {
    icon: FaDna,
    title: 'Lab',
    path: '/lab',
    permissions: actions.VIEW_LAB_MENU,
    menu: 'folder',
  },
  {
    icon: FaBriefcaseMedical,
    title: 'Lab CSV Files',
    path: '/lab-files',
    permissions: actions.VIEW_LAB_FILES_PAGE,
    component: LabFilesPage,
    menu: 'lab',
  },
  {
    icon: FaNotesMedical,
    title: 'Lab Samples',
    path: '/lab-samples',
    permissions: actions.VIEW_LAB_SAMPLES_PAGE,
    component: LabSamplesPage,
    menu: 'lab',
  },
  {
    icon: AiFillReconciliation,
    title: 'Local Manager',
    path: '/manager',
    permissions: actions.VIEW_MANAGER_MENU,
    menu: 'folder',
  },
  {
    icon: FaBarcode,
    title: 'Serial',
    path: '/manager-serials',
    permissions: actions.VIEW_MANAGER_MENU,
    component: ManagerSerialPage,
    menu: 'manager',
  },
  {
    icon: FaBarcode,
    title: 'Serial Dashboard',
    path: '/manager-serialDashboard',
    permissions: actions.VIEW_MANAGER_MENU,
    component: ManagerSerialDashboardPage,
    menu: 'manager',
  },
  {
    icon: AiFillReconciliation,
    title: 'Registration',
    path: '/manager-registrations',
    permissions: actions.VIEW_MANAGER_MENU,
    component: ManagerRegistrationTabPage,
    menu: 'manager',
  },
  {
    icon: FaStethoscope,
    title: 'Doctors Management',
    path: '/manager-doctors',
    permissions: actions.VIEW_MANAGER_MENU,
    component: ManagerDoctorsPage,
    menu: 'manager',
  },
  {
    icon: FaStethoscope,
    title: 'Corporations Management',
    path: '/manager-corporate',
    permissions: actions.VIEW_MANAGER_MENU,
    component: ManagerCorporatePage,
    menu: 'manager',
  },
  {
    icon: FaUsers,
    title: 'Admin Users Management',
    path: '/users',
    permissions: actions.VIEW_USERS_PAGE,
    component: UsersPage,
    menu: 'main',
  },
];

export default data;
